module.exports = __webpack_public_path__ + "static/img/weiboNews_06.3d85ab8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/weibo/weiboNews_06.jpg
// module id = XKPI
// module chunks = 0